// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FacultyList_faculty-list__G8lLT {
  width: 100%;
  display: flex;
  justify-content: space-between;
  gap: 40px;
}
.FacultyList_faculty-list__cards__5P00f {
  padding: 16px 0px;
  display: flex;
  flex-direction: column;
  gap: 40px;
  align-self: stretch;
}
.FacultyList_faculty-list__G8lLT .FacultyList_results__pPAfk {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 40px;
  align-self: stretch;
  overflow: hidden;
}
.FacultyList_faculty-list__G8lLT .FacultyList_results__header__uFEWr {
  display: flex;
  padding: 0px 40px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 12px;
  align-self: stretch;
}
.FacultyList_faculty-list__G8lLT .FacultyList_results__body__0sS7y {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
  padding: 0 5px;
}
.FacultyList_faculty-list__G8lLT .FacultyList_results--title__j6WDF {
  text-align: center;
  color: var(--accent-color);
  font-family: "Lora", "Roboto", "Helvetica", "Arial", sans-serif;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.FacultyList_faculty-list__G8lLT .FacultyList_results--description__9HQY- {
  color: var(--grey-text);
  text-align: center;
  font-family: "Lora", "Roboto", "Helvetica", "Arial", sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.FacultyList_faculty-list__G8lLT .FacultyList_results--controller__FTYr7 {
  display: flex;
  padding: 0px 16px;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
}
.FacultyList_faculty-list__G8lLT .FacultyList_results--controller__right__DYwmT {
  display: flex;
  align-items: center;
  gap: 8px;
}
.FacultyList_faculty-list__G8lLT .FacultyList_right-section__eMYTi {
  max-width: 300px;
  width: 100%;
}
@media only screen and (max-width: 900px) {
  .FacultyList_faculty-list__G8lLT {
    flex-direction: column;
    gap: 20px;
  }
  .FacultyList_faculty-list__G8lLT .FacultyList_results__pPAfk {
    width: 100%;
  }
  .FacultyList_faculty-list__G8lLT .FacultyList_results--title__j6WDF {
    font-size: 20px;
  }
  .FacultyList_faculty-list__G8lLT .FacultyList_right-section__eMYTi {
    max-width: initial;
  }
}

.FacultyList_related-keywords-wrapper__IoHjt {
  margin-bottom: 20px;
  animation: FacultyList_fadeIn__otflN 0.3s ease-in-out;
}

.FacultyList_keyword-chips__JuxTy {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 10px;
}

.FacultyList_keyword-chip__Mqj9H {
  background-color: #f0f0f0;
  border-radius: 16px;
  padding: 5px 12px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.3s;
}
.FacultyList_keyword-chip__Mqj9H:hover {
  background-color: #e0e0e0;
}

.FacultyList_no-results-message__Is6ke {
  display: block;
  margin-bottom: 20px;
  font-size: 16px;
  color: #ff4d4f;
}

@keyframes FacultyList_fadeIn__otflN {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.FacultyList_keyword-list__7hJ5i {
  list-style-type: none;
  padding: 0;
}
.FacultyList_keyword-list__7hJ5i li {
  cursor: pointer;
  margin-bottom: 5px;
}
.FacultyList_keyword-list__7hJ5i li:hover {
  text-decoration: underline;
}

.FacultyList_keyword-stats-selector__bhCfW {
  margin-bottom: 20px;
  display: flex;
  align-items: center;
}

.FacultyList_card__Q6DWg {
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 16px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
.FacultyList_card__Q6DWg:hover {
  transform: translateY(-4px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
  background: rgba(255, 255, 255, 0.9);
  border-color: rgba(30, 58, 95, 0.1);
}`, "",{"version":3,"sources":["webpack://./src/Explore/Pages/FacultyList/FacultyList.module.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,aAAA;EACA,8BAAA;EACA,SAAA;AACF;AACE;EACE,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,mBAAA;AACJ;AAEE;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;EACA,gBAAA;AAAJ;AAEI;EACE,aAAA;EACA,iBAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AAAN;AAGI;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;EACA,cAAA;AADN;AAII;EACE,kBAAA;EACA,0BAAA;EACA,+DAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAFN;AAKI;EACE,uBAAA;EACA,kBAAA;EACA,+DAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAHN;AAMI;EACE,aAAA;EACA,iBAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AAJN;AAMM;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAJR;AASE;EACE,gBAAA;EACA,WAAA;AAPJ;AAUE;EAlFF;IAmFI,sBAAA;IACA,SAAA;EAPF;EASE;IACE,WAAA;EAPJ;EASI;IACE,eAAA;EAPN;EAWE;IACE,kBAAA;EATJ;AACF;;AAaA;EACE,mBAAA;EACA,qDAAA;AAVF;;AAaA;EACE,aAAA;EACA,eAAA;EACA,SAAA;EACA,gBAAA;AAVF;;AAaA;EACE,yBAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,eAAA;EACA,iCAAA;AAVF;AAYE;EACE,yBAAA;AAVJ;;AAcA;EACE,cAAA;EACA,mBAAA;EACA,eAAA;EACA,cAAA;AAXF;;AAcA;EACE;IACE,UAAA;IACA,4BAAA;EAXF;EAcA;IACE,UAAA;IACA,wBAAA;EAZF;AACF;AAeA;EACE,qBAAA;EACA,UAAA;AAbF;AAeE;EACE,eAAA;EACA,kBAAA;AAbJ;AAeI;EACE,0BAAA;AAbN;;AAkBA;EACE,mBAAA;EACA,aAAA;EACA,mBAAA;AAfF;;AAkBA;EACE,oCAAA;EACA,2BAAA;EACA,mCAAA;EACA,0CAAA;EACA,mBAAA;EACA,iDAAA;AAfF;AAiBE;EACE,2BAAA;EACA,0CAAA;EACA,oCAAA;EACA,mCAAA;AAfJ","sourcesContent":[".faculty-list {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  gap: 40px;\n\n  &__cards {\n    padding: 16px 0px;\n    display: flex;\n    flex-direction: column;\n    gap: 40px;\n    align-self: stretch;\n  }\n\n  .results {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 40px;\n    align-self: stretch;\n    overflow: hidden;\n\n    &__header {\n      display: flex;\n      padding: 0px 40px;\n      flex-direction: column;\n      justify-content: center;\n      align-items: center;\n      gap: 12px;\n      align-self: stretch;\n    }\n\n    &__body {\n      display: flex;\n      flex-direction: column;\n      align-items: flex-start;\n      gap: 16px;\n      align-self: stretch;\n      padding: 0 5px;\n    }\n\n    &--title {\n      text-align: center;\n      color: var(--accent-color);\n      font-family: \"Lora\", \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\n      font-size: 24px;\n      font-style: normal;\n      font-weight: 700;\n      line-height: normal;\n    }\n\n    &--description {\n      color: var(--grey-text);\n      text-align: center;\n      font-family: \"Lora\", \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\n      font-size: 16px;\n      font-style: normal;\n      font-weight: 500;\n      line-height: normal;\n    }\n\n    &--controller {\n      display: flex;\n      padding: 0px 16px;\n      justify-content: space-between;\n      align-items: center;\n      align-self: stretch;\n\n      &__right {\n        display: flex;\n        align-items: center;\n        gap: 8px;\n      }\n    }\n  }\n\n  .right-section {\n    max-width: 300px;\n    width: 100%;\n  }\n\n  @media only screen and (max-width: 900px) {\n    flex-direction: column;\n    gap: 20px;\n\n    .results {\n      width: 100%;\n\n      &--title {\n        font-size: 20px;\n      }\n    }\n\n    .right-section {\n      max-width: initial;\n    }\n  }\n}\n\n.related-keywords-wrapper {\n  margin-bottom: 20px;\n  animation: fadeIn 0.3s ease-in-out;\n}\n\n.keyword-chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  margin-top: 10px;\n}\n\n.keyword-chip {\n  background-color: #f0f0f0;\n  border-radius: 16px;\n  padding: 5px 12px;\n  font-size: 14px;\n  cursor: pointer;\n  transition: background-color 0.3s;\n\n  &:hover {\n    background-color: #e0e0e0;\n  }\n}\n\n.no-results-message {\n  display: block;\n  margin-bottom: 20px;\n  font-size: 16px;\n  color: #ff4d4f;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.keyword-list {\n  list-style-type: none;\n  padding: 0;\n\n  li {\n    cursor: pointer;\n    margin-bottom: 5px;\n\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n}\n\n.keyword-stats-selector {\n  margin-bottom: 20px;\n  display: flex;\n  align-items: center;\n}\n\n.card {\n  background: rgba(255, 255, 255, 0.7);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  border: 1px solid rgba(255, 255, 255, 0.3);\n  border-radius: 16px;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n\n  &:hover {\n    transform: translateY(-4px);\n    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);\n    background: rgba(255, 255, 255, 0.9);\n    border-color: rgba(30, 58, 95, 0.1);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"faculty-list": `FacultyList_faculty-list__G8lLT`,
	"faculty-list__cards": `FacultyList_faculty-list__cards__5P00f`,
	"results": `FacultyList_results__pPAfk`,
	"results__header": `FacultyList_results__header__uFEWr`,
	"results__body": `FacultyList_results__body__0sS7y`,
	"results--title": `FacultyList_results--title__j6WDF`,
	"results--description": `FacultyList_results--description__9HQY-`,
	"results--controller": `FacultyList_results--controller__FTYr7`,
	"results--controller__right": `FacultyList_results--controller__right__DYwmT`,
	"right-section": `FacultyList_right-section__eMYTi`,
	"related-keywords-wrapper": `FacultyList_related-keywords-wrapper__IoHjt`,
	"fadeIn": `FacultyList_fadeIn__otflN`,
	"keyword-chips": `FacultyList_keyword-chips__JuxTy`,
	"keyword-chip": `FacultyList_keyword-chip__Mqj9H`,
	"no-results-message": `FacultyList_no-results-message__Is6ke`,
	"keyword-list": `FacultyList_keyword-list__7hJ5i`,
	"keyword-stats-selector": `FacultyList_keyword-stats-selector__bhCfW`,
	"card": `FacultyList_card__Q6DWg`
};
export default ___CSS_LOADER_EXPORT___;
